<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="indigo">view_list</v-icon>
      项目基本信息
      <v-spacer/>

      <v-btn
        flat round color="primary" dark
        :disabled="!funcIds.includes('c_proj_project') || project.status.identifier === 'checked'"
        @click.native.stop="
             () => {
                  editDbid = item.dbid;
                  edit = true;
                }">
        <v-icon>edit</v-icon>
        修改基本信息
      </v-btn>

    </v-card-title>
    <v-divider color="indigo"/>
    <v-card-text class="pt-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm9 lg9>
            <div class="x-text-field">
              <label>项目名称</label>
              <div>{{item.name}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>项目类别</label>
              <div>{{item.type ? item.type.name: ''}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg4>
            <div class="x-text-field">
              <label>委托单位</label>
              <div>{{item.client}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg2>
            <div class="x-text-field">
              <label>项目编号</label>
              <div>{{item.code}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg2>
            <div class="x-text-field">
              <label>项目批准号</label>
              <div>{{item.number}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>开始日期</label>
              <div>{{item.startDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>结束日期</label>
              <div>{{item.finishDate}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>归属部门</label>
              <div>{{ item.department ? item.department.name : '' }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>负责人</label>
              <div>{{item.leaderName}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>负责人电话</label>
              <div>{{item.leaderPhone}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>负责人邮箱</label>
              <div>{{item.leaderEmail}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>学科分类</label>
              <div>{{item.subject ? item.subject.name: ''}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>项目性质</label>
              <div>{{propMap[item.property] || item.property}}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>组织形式</label>
              <div>{{ item.organizeForm }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>合作形式</label>
              <div>{{ item.coopeForm ? item.coopeForm.name : '' }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>研究活动类别</label>
              <div>{{ item.researchType ? item.researchType.name : '' }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>合同金额</label>
              <div>{{ item.contractAmounts | currency }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm3 lg3>
            <div class="x-text-field">
              <label>实到金额</label>
              <div>{{ (item.income || 0) | currency }}</div>
            </div>
          </v-flex>

          <v-flex xs12 sm2 lg2>
            <div class="x-text-field">
              <label>项目状态</label>
              <div>{{ item.status ? item.status.name : '' }}</div>
            </div>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XEdit from './Edit'

  export default {
    components: {XEdit},

    props: {
      project: Object
    },

    data: () => ({
      item: {},
      propMap: {
        "zk": "自科",
        "sk": "社科"
      },

      edit: false,
      editDbid: null,
    }),

    watch: {
      project(v) {
        if (v) this.item = v;
      }
    },
    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      onEditOk(v) {
        if (v) {
          this.item = window.xutil.clone(v);
          this.$emit("ok", this.item);
        }
      }
    }
  }
</script>
